// import API from "../../../app/api";

// class MenuService {
//   async getMegaMenu() {
//     try {
//       const response = await API.get("/megamenu");
//       return response.data;
//     } catch (error) {
//       throw (
//         error.response?.data || {
//           success: false,
//           message: "Something went wrong",
//         }
//       );
//     }
//   }
// }
// export default new MenuService();

import API from "../../../app/api";

export const getMenuService = async () => {
  try {
    const res = await API.get("/megamenu");
    if (res.data?.success) {
      return res.data.data || [];
    }
    return [];
  } catch (error) {
    console.error("Mega Menu Error:", error);
    return [];
  }
};